import React from "react";
import Button from "../shared/Button";
import useEstatesFilterStore from "../stores/useEstatesFilterStore";
import styled from "styled-components";
import { PURPOSES } from "../../helpers/constants";

const PurposeTabs = () => {
  const purpose = useEstatesFilterStore((state) => state.purpose);
  const setPurpose = useEstatesFilterStore((state) => state.setPurpose);

  return (
    <StyleWrapper className="estate__tabs">
      {PURPOSES.map((category) => (
        <Button
          key={category.id}
          color={purpose === category.id && "danger"}
          variant="contained"
          className="estate__tabs__btn"
          onClick={() => setPurpose(category.id)}
        >
          {category.name}
        </Button>
      ))}
    </StyleWrapper>
  );
};

const StyleWrapper = styled.div`
  display: flex;
  gap: 8px;
  margin: 10px 15px 0 15px;

  .estate__tabs__btn {
    height: 42px;
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    padding-left: 30px;
    padding-right: 30px;
    &:not(.danger) {
      background-color: var(--menu-active-color);
      color: var(--light-grey-text);
      border: 1px splid #6875881a;
    }
  }
`;

export default PurposeTabs;
